import { type ReactNode, useEffect } from 'react';
import { Navigate } from 'react-router-dom';

import { api } from '../lib/api-client';
import { useAuthStore } from '../stores/auth-store';

/**
 * Guard de rota — redireciona para /login se sem accessToken;
 * carrega `/v1/auth/me` quando há token mas ainda não há user (boot).
 */
export function RequireAuth({ children }: { children: ReactNode }): JSX.Element {
  const accessToken = useAuthStore((s) => s.accessToken);
  const user = useAuthStore((s) => s.user);
  const isHydrating = useAuthStore((s) => s.isHydrating);
  const setMe = useAuthStore((s) => s.setMe);
  const setHydrating = useAuthStore((s) => s.setHydrating);
  const clear = useAuthStore((s) => s.clear);

  useEffect(() => {
    if (!accessToken || user || isHydrating) return;
    setHydrating(true);
    api
      .me()
      .then((me) => setMe(me))
      .catch(() => clear())
      .finally(() => setHydrating(false));
  }, [accessToken, user, isHydrating, setMe, setHydrating, clear]);

  if (!accessToken) {
    return <Navigate to="/login" replace />;
  }
  if (!user) {
    // Aguardando hidratação do /me — placeholder simples.
    return (
      <div className="flex h-screen items-center justify-center text-text-secondary">
        Carregando sessão…
      </div>
    );
  }
  return <>{children}</>;
}
